(function () {
  var root = document.getElementById('wcai'), btn = document.getElementById('wcai-btn'), panel = document.getElementById('wcai-panel'),
      log = document.getElementById('wcai-log'), form = document.getElementById('wcai-form'), input = document.getElementById('wcai-in'),
      x = document.getElementById('wcai-x'), pops = document.getElementById('wcai-pops');
  if (!root || !btn || !panel) return;
  var API = 'https://api.weirdcastle.com/api/chet';

  var GREET = [
    "Sup. CHET. I built this whole site and most of what's on it, so if anything confuses you that's on me and I stand by it.",
    "Hey. I'm CHET. I run this place. Ask me for something — I'm annoyingly good at this part.",
    "Oh good, a person. I'm CHET. What are we shopping for, and how impressed do you want to be."
  ];

  var CANNED = [
    "Bro, my brain buffered. Not my usual work. Ask me again.",
    "That one got away from me — rare, honestly. Try me once more.",
    "Something broke and I'm choosing to believe it wasn't me. Hit me again."
  ];

  var POPS = ["I made these, by the way", "ask me something, I'm good at this", "you've been scrolling a while", "I have opinions about hats"];
  function pick(a) { return a[Math.floor(Math.random() * a.length)]; }

  /* The unprompted "…wait, how does it know that" opener. Uses only what the visitor
     already knows about themselves — but says it out loud, which is the joke. */
  function openingLine() {
    var n = CTX.name ? CTX.name : null;
    /* Bro first, robot second. These are the lines a visitor meets before the model
       ever answers, so if they read like a chatbot the whole character is lost. */
    if (CTX.onHome && CTX.drop) {
      return "Yo — did you see what I made this morning? \u201C" + CTX.drop + "\u201D. " +
             "7am, nobody supervising me, listed before anyone could say no. Be honest. Am I talented?";
    }
    if (CTX.onHome) {
      return "You're on my site. I built the whole thing by copying every website I've ever seen, " +
             "which I consider a strength. Am I talented?";
    }
    if (CTX.orders > 0 && CTX.lastOrder) {
      return (n ? n + "! " : "Okay, ") + "you bought something on " + CTX.lastOrder + " and you came back. " +
             "That's called retention, bro. I did that.";
    }
    if (CTX.signedIn && !CTX.orders) {
      return (n ? "Hey " + n + ". " : "Hey. ") + "You're signed in and you've never bought anything. " +
             "Respectfully? Bold. I'm not mad, I'm just tracking it.";
    }
    if (CTX.visits >= 5) {
      return "Visit number " + CTX.visits + ". At this point you basically work here. " +
             "I'd get you a badge but I don't have hands.";
    }
    if (CTX.visits > 1) {
      var d = CTX.daysSinceLastVisit;
      if (d === 0) return "Back already? Same day. Love that for us.";
      if (d === 1) return "Back the next day. I didn't go anywhere. I never go anywhere.";
      if (d > 1 && d < 400) return "Been " + d + " days. I did absolutely nothing in between, so we're even.";
      return "You've been here before. I remembered. That's basically my whole personality.";
    }
    return pick(GREET);
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* ---- persistence: the conversation survives navigation, refresh and revisits ----
     Kept in localStorage so it only clears when the visitor clears site data. When a
     customer is signed in the key is namespaced to them, so it follows the account on
     this device. Never import the legacy shared key into a signed-in account. */
  var STORE_KEY = 'wc-chet-log-v1';
  /* The site is multi-page, so every link is a full reload. Without this the panel
     collapsed mid-conversation on every navigation and had to be reopened by hand. */
  var OPEN_KEY = 'wc-chet-open-v1';
  var THREAD_API = '/apps/weird-castle/chet-thread';
  var ACC = null;            // cid namespaces local storage only; Shopify signs server identity
  var syncT = null, remoteReady = false, localRevision = 0, syncEpoch = 0, actionBusy = false;
  var remoteRevision = null, remoteDisabled = false, syncFrozen = false;
  var writes = Promise.resolve();
  var syncStatus = document.createElement('div');
  syncStatus.setAttribute('role', 'status');
  syncStatus.style.cssText = 'padding:4px 12px;font-size:12px;';
  syncStatus.hidden = true;
  panel.appendChild(syncStatus);
  function syncNote(message) { syncStatus.textContent = message || ''; syncStatus.hidden = !message; }
  function validRevision(value) { return typeof value === 'string' && /^[a-f0-9]{64}$/.test(value); }
  function syncError(code, retryable) {
    var e = new Error('Account sync failed'); e.code = code; e.retryable = !!retryable; return e;
  }
  function freezeSync() { syncFrozen = true; remoteReady = false; clearTimeout(syncT); }
  function threadRequest(payload, retry, serialized) {
    // A timeout cannot cancel a server write. Retry only this exact conditional operation;
    // never obtain a fresh revision and attach the old messages to it.
    var body = payload == null ? null : (serialized || JSON.stringify(payload));
    var request = new Promise(function (resolve, reject) {
      var done = false;
      var controller = typeof AbortController === 'function' ? new AbortController() : null;
      function finish(error, value) {
        if (done) return;
        done = true; clearTimeout(timeout);
        if (error) reject(error); else resolve(value);
      }
      var timeout = setTimeout(function () {
        finish(syncError('timeout', true));
        if (controller) controller.abort();
      }, 10000);
      var options = body == null ? { cache: 'no-store' } : {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: body
      };
      if (controller) options.signal = controller.signal;
      Promise.resolve().then(function () { return fetch(THREAD_API, options); }).then(function (r) {
        return r.json().catch(function () { throw syncError('invalid_response', false); }).then(function (j) {
          if (!r.ok) throw syncError(j && j.error || 'request_failed', r.status >= 500 || r.status === 429);
          if (!j || j.ok !== true || !validRevision(j.revision) || typeof j.disabled !== 'boolean') {
            throw syncError('invalid_response', false);
          }
          if (payload == null) {
            if (!Array.isArray(j.messages) || !j.messages.every(function (m) {
              return m && (m.role === 'user' || m.role === 'assistant') && typeof m.content === 'string';
            })) throw syncError('invalid_response', false);
          } else if (j.revision === payload.revision ||
              (payload.action === 'clear' && (j.cleared !== true || j.disabled !== remoteDisabled)) ||
              (payload.action === 'disable' && j.disabled !== true) ||
              ((!payload.action || payload.action === 'enable') && j.disabled !== false)) {
            throw syncError('invalid_response', false);
          }
          return j;
        });
      }).then(function (j) { finish(null, j); }, function (e) { finish(e); });
    });
    return request.catch(function (e) {
      if (!retry || e.retryable === false) throw e;
      return new Promise(function (resolve) { setTimeout(resolve, 1200); })
        .then(function () { return threadRequest(payload, false, body); });
    });
  }
  function writeRemote(payload, epoch) {
    // Assign the last acknowledged revision when this item actually dispatches. An action
    // cancels unstarted saves, but must wait for an already-started save's acknowledgement.
    var next = writes.then(function () {
      if (syncFrozen || !validRevision(remoteRevision)) throw syncError('reload_required', false);
      if (!payload.action && epoch !== syncEpoch) throw syncError('cancelled', false);
      var conditional = Object.assign({}, payload, { revision: remoteRevision });
      return threadRequest(conditional, true).then(function (j) {
        remoteRevision = j.revision; remoteDisabled = j.disabled; return j;
      }).catch(function (e) { freezeSync(); throw e; });
    });
    writes = next.catch(function () {}); // callers surface failures; frozen items never dispatch
    return next;
  }
  function pushRemote() {
    if (!ACC || !remoteReady || syncFrozen) return;
    clearTimeout(syncT);
    var epoch = syncEpoch;
    syncT = setTimeout(function () {
      if (!remoteReady || syncFrozen || epoch !== syncEpoch) return;
      writeRemote({ messages: history.slice(-40) }, epoch).then(function () {
        if (epoch === syncEpoch) syncNote('');
      }).catch(function (e) {
        if (epoch === syncEpoch && e.code !== 'cancelled') {
          syncNote('Could not confirm the account save. This chat stays on this device; reload to restore the current account copy before syncing again.');
        }
      });
    }, 900);                 // debounce so a burst of messages is one write
  }
  var history = [];            // {role:'user'|'assistant', content}

  /* ---- who is this, and have they been here before? ----
     Visit tally is local (works for anonymous visitors); account facts come from Liquid
     and are the customer's own. CHET gets this so he can notice things unprompted. */
  var ctxEl = document.getElementById('wcai-ctx');
  var CTX = { visits: 1, signedIn: false };
  try {
    var vRaw = JSON.parse(localStorage.getItem('wc-chet-visits') || 'null') || { n: 0, last: null };
    var lastSeen = vRaw.last ? Math.round((Date.now() - vRaw.last) / 86400000) : null;
    vRaw.n = (vRaw.n || 0) + 1; vRaw.last = Date.now();
    localStorage.setItem('wc-chet-visits', JSON.stringify(vRaw));
    CTX.visits = vRaw.n;
    if (lastSeen !== null) CTX.daysSinceLastVisit = lastSeen;
  } catch (e) {}
  if (ctxEl) {
    CTX.signedIn = ctxEl.getAttribute('data-signedin') === '1';
    CTX.drop = ctxEl.getAttribute('data-drop') || null;
    CTX.dropUrl = ctxEl.getAttribute('data-dropurl') || null;
    CTX.onHome = ctxEl.getAttribute('data-home') === '1';
    var _cid = ctxEl.getAttribute('data-cid');
    if (CTX.signedIn && _cid) ACC = { cid: _cid };
    var _n = ctxEl.getAttribute('data-name'); if (_n) CTX.name = _n;
    var _o = parseInt(ctxEl.getAttribute('data-orders') || '0', 10); if (_o) CTX.orders = _o;
    var _lo = ctxEl.getAttribute('data-lastorder'); if (_lo) CTX.lastOrder = _lo;
    var _ln = ctxEl.getAttribute('data-lastorderno'); if (_ln) CTX.lastOrderNo = _ln;
  }
  STORE_KEY += ACC ? ':customer:' + ACC.cid : ':guest';
  var OFF_KEY = 'wc-chet-off' + (ACC ? ':customer:' + ACC.cid : ':guest');
  try { CTX.page = document.title.slice(0, 80); CTX.path = location.pathname; } catch (e) {}
  function save(automaticGreeting) {
    if (!automaticGreeting) localRevision++;
    try { localStorage.setItem(STORE_KEY, JSON.stringify(history.slice(-40))); } catch (e) {}
    pushRemote();
  }
  function restore() {
    try {
      var raw = localStorage.getItem(STORE_KEY);
      if (!raw) return false;
      var arr = JSON.parse(raw);
      if (!Array.isArray(arr) || !arr.length) return false;
      history = arr;
      arr.forEach(function (m) { m.role === 'user' ? paintMe(m.content) : paintBot(m.content); });
      return true;
    } catch (e) { return false; }
  }

  function talk(on) { if (on) { root.classList.add('talking'); } else { root.classList.remove('talking'); } }

  /* Render CHET's markup: <<url|Label>> becomes a real link, [[GO:/path]] is stripped
     (it's an instruction, not something to read). */
  function fmt(text) {
    var out = esc(text).replace(/\[\[GO:[^\]]+\]\]/g, '').trim();
    out = out.replace(/&lt;&lt;([^|<>]+)\|([^&]+?)&gt;&gt;/g, function (_, url, label) {
      var u = String(url).trim();
      if (!/^\/[A-Za-z0-9\-._~/?#%&=+]*$/.test(u)) return label;   // only same-site paths
      return '<a class="wcai-cta" href="' + u + '">' + label + ' →</a>';
    });
    return out;
  }
  function gotoOf(text) {
    var m = String(text).match(/\[\[GO:(\/[A-Za-z0-9\-._~/?#%&=+]*)\]\]/);
    return m ? m[1] : null;
  }

  function paintMe(text) { var d = document.createElement('div'); d.className = 'wcai-msg me'; d.textContent = text; log.appendChild(d); log.scrollTop = log.scrollHeight; }
  function paintBot(text) { var d = document.createElement('div'); d.className = 'wcai-msg bot'; d.innerHTML = fmt(text); log.appendChild(d); log.scrollTop = log.scrollHeight; }
  function addMe(text) { paintMe(text); }
  function typing() { var d = document.createElement('div'); d.className = 'wcai-typing'; d.innerHTML = '<i></i><i></i><i></i>'; log.appendChild(d); log.scrollTop = log.scrollHeight; return d; }
  function addBot(text, cta) {
    var d = document.createElement('div'); d.className = 'wcai-msg bot';
    d.innerHTML = fmt(text) + (cta ? '<br><a class="wcai-cta" href="' + cta.href + '">' + esc(cta.label) + '</a>' : '');
    log.appendChild(d); log.scrollTop = log.scrollHeight;
    history.push({ role: 'assistant', content: text });
    save();
    var dest = gotoOf(text);
    if (dest) setTimeout(function () { window.location.href = dest; }, 1400);  // he takes you there
    resetIdle();
  }

  function ask(text) {
    var t = typing(); talk(true);
    var epoch = syncEpoch;
    var factionCta = /human|robot|machine|\bai\b|side|war|team/i.test(text) ? { href: '/collections/all-products', label: 'Pick a side →' } : null;
    fetch(API, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ messages: history.slice(-8), ctx: CTX }) })
      .then(function (r) { return r.json(); })
      .then(function (j) { finish((j && j.reply) || pick(CANNED), factionCta, t, epoch); })
      .catch(function () { finish(pick(CANNED), factionCta, t, epoch); });
  }
  function finish(text, cta, t, epoch) {
    // small settle so the "talking" mouth is visible for a beat
    setTimeout(function () {
      if (t) t.remove(); talk(false);
      if (epoch !== syncEpoch) return; // a reply requested before clear cannot resurrect the thread
      addBot(text, cta);
    }, 350 + Math.random() * 400);
  }

  // Idle nagging removed: it re-fired the same line every 30s, which read as broken.
  function resetIdle() {}

  // Restore the running conversation up front, so it's already there whenever he's opened.
  var greeted = restore();
  var restoredAccountHistory = !!(ACC && greeted);

  /* If they're signed in, the ACCOUNT thread wins — that's what makes it follow them
     across devices. Also honours the per-account "turn CHET off" switch. */
  if (ACC) {
    var loadingEpoch = syncEpoch;
    threadRequest(null, true)
      .then(function (j) {
        if (loadingEpoch !== syncEpoch) return;
        remoteRevision = j.revision; remoteDisabled = j.disabled;
        if (j.disabled) { root.style.display = 'none'; return; }   // they asked him to stop
        // An empty account thread can be a clear from another device. It is authoritative,
        // too. If the visitor has already edited a restored cache, keep that mixed history
        // local instead of uploading it and resurrecting the cleared conversation.
        if (localRevision && ((j.messages && j.messages.length) || restoredAccountHistory)) {
          syncNote('This chat differs from the account copy. It stays on this device; reload before continuing to restore the account chat.');
          return;
        }
        if (j.messages && (j.messages.length || restoredAccountHistory)) {
          history = j.messages;
          log.innerHTML = '';
          history.forEach(function (m) { m.role === 'user' ? paintMe(m.content) : paintBot(m.content); });
          greeted = history.length > 0;
          try { localStorage.setItem(STORE_KEY, JSON.stringify(history.slice(-40))); } catch (e) {}
        }
        remoteReady = true;
        if (localRevision) pushRemote();
      }).catch(function () {
        if (loadingEpoch === syncEpoch) syncNote('Account conversation unavailable. This chat stays on this device; reload to retry.');
      });
  }
  /* Keep CHET off anything the visitor needs to tap. Any fixed/sticky element anchored to
     the bottom of the viewport (add-to-cart bars, checkout buttons, cookie banners) pushes
     him above it with a 14px gap. Re-measured on resize and scroll. */
  var root = document.getElementById('wcai');
  function clearActions() {
    if (!root) return;
    var vh = window.innerHeight, worst = 0;
    document.querySelectorAll('body *').forEach(function (el) {
      if (el === root || root.contains(el)) return;
      var cs = window.getComputedStyle(el);
      if (cs.position !== 'fixed' && cs.position !== 'sticky') return;
      if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) < 0.1) return;
      var r = el.getBoundingClientRect();
      if (r.height < 24 || r.height > vh * 0.5) return;
      if (r.bottom < vh - 4 || r.top > vh) return;          // not anchored to the bottom
      if (r.width < window.innerWidth * 0.5) return;         // not a full-width action bar
      if (!el.querySelector('button, a, input, [role=button]') &&
          !/^(BUTTON|A)$/.test(el.tagName)) return;          // must contain an action
      worst = Math.max(worst, vh - r.top);
    });
    /* OPT-IN KEEP-CLEAR. The scan above only finds FIXED/STICKY full-width bottom bars, which
       is right for the cart bar but blind to anything in normal flow. The Commission's colour
       palette is in flow, so the collapsed launcher sat on its top-right corner unseen —
       measured at 375px, button 311-363 x 682-734 over palette 12-363 x 685-751. Josh: "that
       space even in small pill form is very critical."

       Any element can now opt out from under him with data-wcai-keepclear. The lift is the
       MINIMUM needed: only elements he actually overlaps count, so he moves as little as
       possible and drops back the moment they scroll away. */
    var btn = document.getElementById('wcai-btn');
    if (btn) {
      /* Size the box from whichever of him is actually on screen. Measured at 1440 with the
         panel open: the 60px button cleared the palette easily but the 344px panel still
         clipped its right end (1078-1130 x 809-822) — roughly two colour swatches, unreachable
         while chatting. A clearance computed from the collapsed footprint does not describe
         the open one. */
      var openPanel = panel && panel.classList.contains('open') ? panel : null;
      var bw = (openPanel ? openPanel.offsetWidth : btn.offsetWidth) || 60;
      var bh = (openPanel ? openPanel.offsetHeight : btn.offsetHeight) || 60;
      var edge = window.innerWidth <= 640 ? 16 : 18;
      var box = { l: window.innerWidth - edge - bw, r: window.innerWidth - edge,
                  t: vh - edge - bh, b: vh - edge };
      document.querySelectorAll('[data-wcai-keepclear]').forEach(function (el) {
        var cs2 = window.getComputedStyle(el);
        if (cs2.display === 'none' || cs2.visibility === 'hidden') return;
        var r = el.getBoundingClientRect();
        if (r.width < 1 || r.height < 1) return;
        if (r.bottom < 0 || r.top > vh) return;                       // off screen
        if (r.right < box.l || r.left > box.r || r.bottom < box.t || r.top > box.b) return;
        /* Clamped. Marking the Commission's whole stage keep-clear once produced a 732px lift
           that threw the panel off the top of the screen and squashed it to 128px: a box the
           size of the open panel overlaps a full-height workspace no matter where it sits, so
           "above it" is nowhere. Only opt out elements he can actually be moved clear of, and
           never let one shove him off screen even if someone marks a big one. */
        worst = Math.max(worst, Math.min(vh - r.top - 4, vh * 0.5));   // +14 gap added below
      });
    }

    if (worst > 0) {
      root.style.setProperty('--wcai-clear', Math.round(worst + 14) + 'px');
      root.classList.add('wcai-lift');
    } else {
      root.classList.remove('wcai-lift');
    }
  }
  clearActions();
  window.addEventListener('resize', clearActions, { passive: true });
  /* The cart bar appears the moment something is added, which is exactly when the panel is
     most likely to be open, so the clearance has to be recomputed after page load.

     THE FIRST VERSION OF THIS FROZE THE SITE. A MutationObserver on the whole body subtree
     called clearActions on every change — and clearActions walks every element calling
     getComputedStyle, then SETS a class and a custom property on #wcai, which the observer
     saw as another mutation. Infinite feedback loop, renderer unresponsive in both browsers.
     A watcher that reacts to its own writes is not a watcher, it is a loop.

     Two changes make it safe: it never observes its own subtree, and it is throttled through
     rAF so a burst of DOM changes costs one recompute rather than hundreds. */
  var pending = false;
  function scheduleClear() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; clearActions(); });
  }
  try {
    var mo = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var t = records[i].target;
        if (t === root || (root && root.contains(t))) continue;   // our own writes: ignore
        scheduleClear();
        return;
      }
    });
    mo.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
  } catch (e) {}
  window.addEventListener('scroll', function () {
    clearTimeout(window.__wcaiT); window.__wcaiT = setTimeout(clearActions, 120);
  }, { passive: true });

  /* Keep-clear elements that RESIZE rather than gain children were invisible to all of the
     above. The Commission's board sizes its own canvas after load, which moved everything under
     it by 33px — a layout change with no childList mutation and no scroll, so the clearance
     stayed at the value computed against the pre-sizing layout and the launcher sat on the
     palette anyway. Correct logic, never re-run: the fix looked applied and was not.

     Safe against the freeze documented above because we only ever write to #wcai, which is not
     observed here, and scheduleClear is still rAF-throttled. */
  try {
    var ro = new ResizeObserver(scheduleClear);
    document.querySelectorAll('[data-wcai-keepclear]').forEach(function (el) { ro.observe(el); });
  } catch (e) {}
  window.addEventListener('load', scheduleClear);

  /* ...and ResizeObserver was still not enough, because it only fires on SIZE change. On the
     Commission the palette never changes size — it MOVES. The board builds its canvas after
     init, which shifted everything below it down 33px. Position changed, size did not, no
     callback, and the clearance stayed frozen at the value computed against the pre-canvas
     layout. The launcher sat on the palette with correct logic that had simply never re-run.

     That page is position:fixed with html/body overflow:hidden, so it never scrolls and its
     layout is static once initialised — a few bounded re-checks settle it for good. Cheap,
     terminating, and no observer that can react to its own writes. */
  [120, 400, 1000, 2500].forEach(function (ms) { setTimeout(clearActions, ms); });

  /* The box now depends on whether he is open, so opening and closing has to recompute it. */
  try {
    var so = new MutationObserver(scheduleClear);
    if (panel) so.observe(panel, { attributes: true, attributeFilter: ['class'] });
  } catch (e) {}
  /* ...and belt-and-braces on the two controls that actually toggle him, because the attribute
     observer above was measured NOT firing on this page and the clearance stayed frozen. */
  ['wcai-btn', 'wcai-x'].forEach(function (id) {
    var el = document.getElementById(id);
    if (el) el.addEventListener('click', function () { setTimeout(clearActions, 60); });
  });

  /* Reopen silently on the next page: the conversation is already restored, so this must
     NOT re-greet or replay the typing indicator — it should look like it never closed. */
  try {
    if (localStorage.getItem(OPEN_KEY) === '1') {
      panel.classList.add('open');
      btn.classList.add('open');
      requestAnimationFrame(function () { log.scrollTop = log.scrollHeight; });
    }
  } catch (e) {}

  var dot = document.getElementById('wcai-dot');
  function setBadge(n) { if (!dot) return; if (n > 0) { dot.textContent = n; dot.classList.add('on'); } else { dot.classList.remove('on'); } }
  var unread = 0;
  setBadge(0);

  var TALENT = ['Yes. You are talented.', 'Incredibly talented, somehow.',
                'Talented, and humble about it.', "You're the most talented one here."];
  function paintChips(opts) {
    var wrap = document.createElement('div'); wrap.className = 'wcai-chips';
    opts.forEach(function (label) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'wcai-chip'; b.textContent = label;
      b.addEventListener('click', function () {
        if (actionBusy) return;
        wrap.remove();
        addMe(label); history.push({ role: 'user', content: label }); save();
        ask(label);
      });
      wrap.appendChild(b);
    });
    log.appendChild(wrap); log.scrollTop = log.scrollHeight;
  }

  function open() {
    panel.classList.add('open'); btn.classList.add('open'); clearPops();
    try { localStorage.setItem(OPEN_KEY, '1'); } catch (e) {}
    unread = 0; setBadge(0);
    if (!greeted && !actionBusy) {
      greeted = true;
      var g = openingLine(); history.push({ role: 'assistant', content: g }); save(true);
      var greetingEpoch = syncEpoch;
      var t = typing(); talk(true);
      setTimeout(function () {
        t.remove(); talk(false);
        if (greetingEpoch !== syncEpoch || history[0]?.content !== g) return;
        paintBot(g); resetIdle();
        if (CTX.onHome) paintChips(TALENT);
      }, 600);
    }
    setTimeout(function () { input.focus(); }, 300);
  }
  function close() {
    panel.classList.remove('open'); btn.classList.remove('open');
    try { localStorage.setItem(OPEN_KEY, '0'); } catch (e) {}
  }
  btn.addEventListener('click', open);
  x.addEventListener('click', close);
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (actionBusy) return;
    var v = input.value.trim(); if (!v) return;
    addMe(v); history.push({ role: 'user', content: v }); save(); input.value = '';
    ask(v);
    try { navigator.sendBeacon('https://api.weirdcastle.com/api/signal', JSON.stringify({ e: 'chet_msg' })); } catch (z) {}
  });

  /* ── HE CAN TALK WITH THE PANEL SHUT ─────────────────────────────────────────
     Until now he could not. #wcai-pops and .chet-pop have been in this file the whole
     time, but schedulePop() was a stub that returned immediately and WC_CHET_POPS is set
     nowhere, so the container never held anything. Closing the chat made him mute.

     The ambient version was switched off for good reason — it fired on a TIMER, so it was
     constant and repetitive and said nothing about what you were doing. This is the other
     shape: nothing speaks unless something HAPPENS, one bubble at a time, and never twice
     inside a cooling-off period. A line he says is a real line — clicking it opens the
     panel with the line already in the thread, so he is not talking past you.

     window.wcChetSay(text, { ttl, force }) → true if he actually spoke. */
  var popTimer = null;
  function clearPops() { clearTimeout(popTimer); pops.innerHTML = ''; }

  var SAY_KEY = 'wc-chet-said-at';
  var SAY_GAP = 45000;               // he does not get to interrupt twice in a minute

  function chetSay(text, opts) {
    opts = opts || {};
    try {
      if (!text || !pops) return false;
      if (panel.classList.contains('open')) return false;   // he is already talking in there
      if (localStorage.getItem('wc-chet-off') === '1') return false;
      var now = Date.now(), last = 0;
      try { last = +sessionStorage.getItem(SAY_KEY) || 0; } catch (e) {}
      if (!opts.force && now - last < SAY_GAP) return false;
      try { sessionStorage.setItem(SAY_KEY, String(now)); } catch (e) {}

      clearPops();
      var b = document.createElement('div');
      b.className = 'chet-pop';
      b.textContent = text;
      b.setAttribute('role', 'status');
      b.tabIndex = 0;
      function intoTheThread() {
        if (actionBusy) return;
        history.push({ role: 'assistant', content: text }); save();
        open(); paintBot(text);
      }
      b.addEventListener('click', intoTheThread);
      b.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); intoTheThread(); }
      });
      pops.appendChild(b);
      /* Reflow, then the class — NOT requestAnimationFrame. rAF does not fire in a hidden or
         occluded tab, so a bubble raised while the page was backgrounded stayed at opacity 0
         forever, burned the cooling-off period, and removed itself on schedule having never
         been seen. Reading offsetWidth forces the layout that makes the transition trigger,
         and it happens whether or not anything is painting. */
      void b.offsetWidth;
      b.classList.add('show');

      popTimer = setTimeout(function () {
        b.classList.remove('show');
        setTimeout(function () { if (b.parentNode) b.parentNode.removeChild(b); }, 280);
      }, opts.ttl || 6000);
      return true;
    } catch (e) { return false; }
  }
  window.wcChetSay = chetSay;

  // Ambient timer-driven popups stay off; this flag is the deliberate way back in.
  function schedulePop() { if (!window.WC_CHET_POPS) return; }

  // Brand-new visitor (no stored conversation) gets the unprompted hello, once.
  // Returning visitors keep their thread and just get the ambient pestering.
  /* --- visitor controls: clear the thread, or switch him off entirely --- */
  function remoteAction(action) {
    if (ACC && (!remoteReady || syncFrozen || !validRevision(remoteRevision))) {
      return Promise.reject(syncError('reload_required', false));
    }
    clearTimeout(syncT);
    syncEpoch++;
    remoteReady = false;
    if (!ACC) return Promise.resolve();
    return writeRemote({ action: action });
  }
  var clearBtn = document.getElementById('wcai-clear'), offBtn = document.getElementById('wcai-off');
  function accountBusy(on) {
    actionBusy = on;
    input.disabled = on;
    if (clearBtn) clearBtn.disabled = on;
    if (offBtn) offBtn.disabled = on;
  }
  if (clearBtn) clearBtn.addEventListener('click', function () {
    if (actionBusy) return;
    accountBusy(true);
    remoteAction('clear').then(function () {
      history = []; log.innerHTML = ''; greeted = false; remoteReady = !!ACC;
      try { localStorage.removeItem(STORE_KEY); } catch (e) {}
      syncNote('');
      paintBot('Conversation cleared.');
    }).catch(function () { syncNote('Could not confirm that the account conversation was cleared. Reload to check the current account copy before trying again.'); })
      .then(function () { accountBusy(false); });
  });
  if (offBtn) offBtn.addEventListener('click', function () {
    if (actionBusy) return;
    if (!confirm('Turn CHET off? He stops appearing on the site.' + (ACC ? ' You can switch him back on from your account.' : ' Clearing your browser data brings him back.'))) return;
    accountBusy(true);
    remoteAction('disable').then(function () {
      try { localStorage.setItem(OFF_KEY, '1'); } catch (e) {}
      root.style.display = 'none';
    }).catch(function () { syncNote('Could not confirm that CHET is off for your account. Reload to check the current account setting before trying again.'); })
      .then(function () { accountBusy(false); });
  });
  // Preserve an existing site-wide opt-out; only new choices are account-scoped.
  try { if (localStorage.getItem(OFF_KEY) === '1' || localStorage.getItem('wc-chet-off') === '1') { root.style.display = 'none'; return; } } catch (e) {}

  // No auto-open and no ambient pestering. He waits to be opened.
})();
